import { Document } from 'src/app/modules/core/store/models/document.model';
import { Layer } from '../../store/cop/models/layer.model';
import { LayerMapFeatures } from './layer-map-features.model';
import { MapDrawingContext } from './map-drawing-context.model';

export interface LayerRenderer {
  /**
   * Implemented to add documents to the map
   * @param drawingContext The drawing context object which contains references to the map and other required objects.
   * @param layer The Layer which contains the documents.
   * @param documents The documents which should be rendered.
   * @param floor Optional selected floor filter
   */
  addDocuments(drawingContext: MapDrawingContext, layer: Layer, documents: Document[], floor?: string): void;

  /**
   * Implemented to remove documents from the map
   * @param drawingContext The drawing context object which contains references to the map and other required objects.
   * @param layer The Layer which contains the documents.
   * @param documentUIds The document uids which should be removed.
   */
  removeDocuments(drawingContext: MapDrawingContext, layer: Layer, documentUIds?: string[]): void;

  /**
   * Implemented to update existing documents drawn on the map. If a document is not present, it will be rendered.
   * @param drawingContext The drawing context object which contains references to the map and other required objects.
   * @param layer The Layer which contains the documents.
   * @param documents The documents which should be updated.
   */
  updateDocuments(drawingContext: MapDrawingContext, layer: Layer, documents: Document[]): void;

  /**
   * Implemented to remove a document.
   * @param drawingContext The drawing context object which contains references to the map and other required objects.
   * @param layer The Layer which contains the documents.
   * @param uid The documentuid which should be removed.
   * @param layerFeatures Features of the document.
   */
  removeDocument(drawingContext: MapDrawingContext, layer: Layer, uid: string, layerFeatures: LayerMapFeatures): void;
}

export const GeometryTypes = {
  feature: 'Feature',
  point: 'Point',
  polygon: 'Polygon',
  lineString: 'LineString',
  multiPolygon: 'MultiPolygon',
  multiLineString: 'MultiLineString'
};
